import { getEdcShopGoodsCategorys } from "@/api";

export function isSecondaryCategorySwitchOn() {
  try {
    const shopInfo = JSON.parse(localStorage.getItem("shopInfo") || "{}");
    return Number(shopInfo.secondaryCategorySwitch) === 1;
  } catch (e) {
    return false;
  }
}

export function getSecondaryCategoryList(parentId, row = 99999, extraParams = {}) {
  return getEdcShopGoodsCategorys({
    pageNo: 1,
    row,
    parentId,
    level: 2,
    ...extraParams,
  });
}

export function createBackCategory() {
  return {
    goodsCategoryId: "__back__",
    categoryName: "返回上级",
  };
}

export function toCategoryCascaderOptions(list = [], options = {}) {
  const { includeAll = true, allLabel = "全部" } = options;
  const switchOn = isSecondaryCategorySwitchOn();
  const nodes = (list || []).map((item) => {
    return {
      value: item.goodsCategoryId,
      label: item.categoryName,
      leaf: !switchOn,
      raw: item,
    };
  });
  if (!includeAll) {
    return nodes;
  }
  return [
    {
      value: "",
      label: allLabel,
      leaf: true,
    },
    ...nodes,
  ];
}

export function getCategoryIdFromCascader(value) {
  if (Array.isArray(value)) {
    if (!value.length) {
      return "";
    }
    return value[value.length - 1];
  }
  return value || "";
}

export function loadSecondaryCategoryForCascader(node, resolve, row = 1000, extraParams = {}) {
  const data = node && node.data;
  if (!isSecondaryCategorySwitchOn() || !data || !data.value) {
    resolve([]);
    return;
  }
  getSecondaryCategoryList(data.value, row, extraParams).then((res) => {
    if (res.code == 1 && res.data && res.data.length) {
      resolve(
        res.data.map((item) => {
          return {
            value: item.goodsCategoryId,
            label: item.categoryName,
            leaf: true,
            raw: item,
          };
        })
      );
      return;
    }
    resolve([]);
  });
}
